/*
  Professions Included:
    - Enchanting
    - Engineering
    - Tailoring
*/

const enchantIdMap: { [key: number]: string } = {
  // Classic & The Burning Crusade (Incomplete)
  41: '+5 Health',
  65: '+1 All Resistances',
  66: '+1 Stamina',
  243: '+1 Spirit',
  247: '+1 Agility',
  248: '+1 Strength',
  255: '+3 Spirit',
  256: '+5 Fire Resistance',
  368: '+12 Agility',
  369: '+12 Intellect',
  684: '+15 Strength',
  723: '+3 Intellect',
  724: '+3 Stamina',
  744: '+20 Armor',
  783: '+10 Armor',
  804: '+10 Shadow Resistance',
  823: '+3 Strength',
  848: '+30 Armor',
  849: '+3 Agility',
  851: '+5 Spirit',
  852: '+5 Stamina',
  856: '+5 Strength',
  884: '+50 Armor',
  903: '+3 All Resistances',
  904: '+5 Agility',
  905: '+5 Intellect',
  907: '+7 Spirit',
  910: 'Increased Stealth',
  911: 'Minor Speed Increase',
  923: '+3 Defense',
  924: '+1 Defense',
  925: '+2 Defense',
  927: '+7 Strength',
  929: '+7 Stamina',
  963: '+7 Weapon Damage',
  1071: '+18 Stamina',
  1144: '+15 Spirit',
  1257: '+15 Arcane Resistance',
  1441: '+15 Shadow Resistance',
  1593: '+24 Attack Power',
  1594: '+26 Attack Power',
  1883: '+7 Intellect',
  1884: '+9 Spirit',
  1885: '+9 Strength',
  1886: '+7 Stamina',
  1887: '+7 Agility',
  1888: '+5 All Resistances',
  1889: '+70 Armor',
  1891: '+4 All Stats',
  1950: '+15 Defense Rating',
  2322: '+35 Healing Spells and +12 Damage Spells',
  2343: '+81 Healing Spells and +27 Damage Spells',
  2463: '+7 Fire Resistance',
  2565: 'Mana Regen 4 per 5 sec',
  2566: 'Healing Spells +24',
  2617: '+30 Healing and +10 Spell Damage',
  2619: '+15 Fire Resistance',
  2620: '+15 Nature Resistance',
  2622: '+1% Dodge',
  2647: '+12 Strength',
  2648: '+12 Defense Rating',
  2649: '+12 Stamina',
  2650: '+12 Spell Damage',
  2653: '+18 Block Value',
  2654: '+12 Intellect',
  2656: 'Vitality',
  2657: '+12 Agility',
  2658: 'Surefooted',
  2659: '+150 Health',
  2660: '+150 Mana',
  2661: '+5 All Stats',
  2662: '+120 Armor',
  2664: '+7 Resist All',
  2666: '+30 Intellect',
  2667: 'Savagery',
  2668: '+20 Strength',
  2669: '+40 Spell Damage and Healing',
  2670: '+35 Agility',
  2671: 'Sunfire',
  2672: 'Soulfrost',
  2673: 'Mongoose',
  2674: 'Spellsurge',
  2675: 'Battlemaster',
  2679: '6 Mana per 5 Sec.',
  2928: '+12 Spell Damage',
  2929: '+2 Weapon Damage',
  2930: '+20 Healing and +7 Spell Damage',
  2931: '+4 All Stats',
  2933: '+15 Resilience Rating',
  2934: '+10 Spell Critical Strike Rating',
  2935: '+15 Spell Hit Rating',
  2937: '+20 Spell Damage',
  2938: '+20 Spell Penetration',
  2939: 'Minor Speed and +6 Agility',
  2940: 'Minor Speed and +9 Stamina',
  3150: '+6 mana every 5 sec',
  3222: '+20 Agility',
  3225: 'Executioner',
  3229: '+12 Resilience Rating',
  3273: 'Deathfrost',
  3368: 'Rune of the Fallen Crusader',
  3370: 'Rune of Razorice',
  3847: 'Rune of the Stoneskin Gargoyle',

  // Battle For Azeroth
  5933: 'Kul Tiran Mining',
  5949: 'Torrent of Elements',
  5945: '+37 Versatility',
  5939: '+27 Haste',
  5946: 'Coastal Surge',
  5940: '+27 Mastery',
  5938: '+27 Critical Strike',
  5966: 'Stalwart Navigation',
  5944: '+37 Mastery',
  5935: 'Kul Tiran Surveying',
  5937: 'Kul Tiran Crafting',
  5934: 'Kul Tiran Skinning',
  5971: 'Cooled Hearthing',
  5941: '+27 Versatility',
  5964: 'Masterful Navigation',
  5948: 'Siphoning',
  5942: '+37 Critical Strike',
  5965: 'Deadly Navigation',
  5970: 'Safe Hearthing',
  5950: 'Gale-Force Striking',
  5943: '+37 Haste',
  5932: 'Kul Tiran Herbalism',
  5962: 'Versatile Navigation',
  5936: 'Swift Hearthing',
  5963: 'Quick Navigation',
  5952: 'Holographic Horror Projector',
  5953: 'Personal Space Amplifier',
  5967: 'Miniaturized Plasma Shield',
  5955: "Crow's Nest Scope",
  5956: 'Monelite Scope of Alacrity',
  5957: 'Incendiary Ammunition',
  5958: 'Frost-Laced Ammunition',
  6087: 'Resilient Spellthread',
  6088: 'Discreet Spellthread',
  6089: 'Feathery Spellthread',

  // Shadowlands
  6163: '+12 Critical Strike',
  6164: '+16 Critical Strike',
  6165: '+12 Haste',
  6166: '+16 Haste',
  6167: '+12 Mastery',
  6168: '+16 Mastery',
  6169: '+12 Versatility',
  6170: '+16 Versatility',
  6202: '+20 Stamina & Minor Speed Increase',
  6203: '+20 Stamina & +30 Avoidance',
  6204: '+20 Stamina & +30 Leech',
  6205: 'Shadowlands Gathering',
  6207: 'Soul Treads',
  6208: '+30 Stamina',
  6209: '+10 Strength',
  6210: '+15 Strength',
  6211: '+15 Agility',
  6212: '+10 Agility',
  6213: '+25 Armor & +20 Primary Stat',
  6214: 'Eternal Skirmish',
  6216: 'Primary Stats +20',
  6217: '+20 Intellect & +6% Mana',
  6219: '+10 Intellect',
  6220: '+15 Intellect',
  6222: 'Shaded Hearthing',
  6223: 'Lightless Force',
  6226: 'Eternal Grace',
  6227: 'Ascended Vigor',
  6228: 'Sinful Revelation',
  6229: 'Celestial Guidance',
  6230: 'Primary Stats +30',
  6241: 'Rune of Sanguination',
  6242: 'Rune of Spellwarding',
  6243: 'Rune of Hysteria',
  6244: 'Rune of Unending Thirst',
  6245: 'Rune of the Apocalypse',
  6265: 'Eternal Insight',
};

export default enchantIdMap;
